import React, { useState, useEffect, useCallback } from "react";
import TextInput from "../fields/TextInput";
import {
  decreaseStep,
  getCarMake,
  getCarModal,
  getCarType,
  getCarFeatures,
  increaseStep,
  storeCarDetails,
  carUploadImages,
  setCarImagesResponse,
} from "../../redux/Slice/formSlice";
import { useDispatch, useSelector } from "react-redux";
import { HiOutlineArrowLeft, HiOutlineArrowRight } from "react-icons/hi";
import { MdOutlineFileUpload } from "react-icons/md";
import SelectInput from "../fields/SelectInput";
import MultipleSelectChip from "../fields/MultiSelect";
import Location from "../fields/Location";
import { Switch } from "@mui/material";
import { scroller } from "react-scroll";
import MapWithModal from "../fields/MapWithLocation";

const CarDetail = ({ CarDetail, setCarDetail }) => {
  const step = useSelector((state) => state?.form?.step);
  const carMakeList = useSelector((state) => state?.form?.carMakeList);
  const carModalList = useSelector((state) => state?.form?.carModalList);
  const carTypeList = useSelector((state) => state?.form?.carTypeList);
  const carFeaturesList = useSelector((state) => state?.form?.carFeaturesList);
  const carDetails = useSelector((state) => state?.form?.carDetails);
  const baseURL = useSelector((state) => state?.config?.baseURL);
  const [gpsAvaiblity, setChecked] = useState(
    carDetails?.gpsAvaiblity || false
  );
   const [driverToggle, setDriverChecked] = useState( carDetails?.driverToggle || false)
  const dispatch = useDispatch(); 
  const [feature, setFeature] = useState([]);
  const [errmsg, setErrMsg] = useState({
    numberPlateImg: "",
    carRightImg: "",
    carLeftImg: "",
    carBackImg: "",
    carSeatsImg: "",
    carInteriorImg: "",
    carDashboardImg: "",
    carChassisImg: "",
    carFrontImg: "",
    power: "",
    carFeature: "",
    speed: "",
    motor: "",
    fuelType: "",
    mileage: "",
    carMake: "",
    carModel: "",
    carType: "",
    manufactureYr: "",
    registrationNum: "",
    seat: "",
    location: "",
  });
  const [location, setLocation] = useState(carDetails?.carLocation || "");
  const editCarID = useSelector((state) => state?.form?.editCarID);
  useEffect(() => {
    dispatch(getCarMake());
    dispatch(getCarType());
    dispatch(getCarFeatures());
  }, []);
  const seatList = [
    {
      _id: "2",
      name: "2 Seater",
    },
    {
      _id: "3",
      name: "3 Seater",
    },
    {
      _id: "4",
      name: "4 Seater",
    },
    {
      _id: "5",
      name: "5 Seater",
    },
    {
      _id: "6",
      name: "6 Seater",
    },
    {
      _id: "7",
      name: "7+ Seater",
    },
  ];

  const FuelType = [
    {
      _id: "Diesel",
      name: "Diesel",
    },
    {
      _id: "Petrol",
      name: "Petrol",
    },
    {
      _id: "Electric",
      name: "Electric",
    },
    {
      _id: "Gas",
      name: "Gas",
    },
    {
      _id: "Hybrid",
      name: "Hybrid",
    },
  ];
  // console.log("location", location);
  // function renameCarMake(data) {
  //   return data?.map((item) => {
  //     const { carMake, ...rest } = item;
  //     return { name: carMake, ...rest };
  //   });
  // }

  // function renameCarModal(data) {
  //   return data?.map((item) => {
  //     const { carModel, ...rest } = item;
  //     return { name: carModel, ...rest };
  //   });
  // }

  // function renameCarType(data) {
  //   return data?.map((item) => {
  //     const { categoryName, ...rest } = item;
  //     return { name: categoryName, ...rest };
  //   });
  // }

  // function renameCarFeature(data) {
  //   return data?.map((item) => {
  //     const { carFeature, ...rest } = item;
  //     return { name: carFeature, ...rest };
  //   });
  // }

  // function availableSeat(carType, seatList) {
  //   if (carType) {
  //     let data = carTypeList?.find((item) => item._id === carType);

  //     // console.log("carTypeList", data?.numberOfSeats);
  //     return seatList?.filter((item) => +item?._id >= +data?.numberOfSeats);
  //   } else {
  //     return [];
  //   }
  // }
  const renameCarMake = useCallback((data) => {
    return data?.map((item) => {
      const { carMake, ...rest } = item;
      return { name: carMake, ...rest };
    });
  }, []);

  const renameCarModal = useCallback((data) => {
    return data?.map((item) => {
      const { carModel, ...rest } = item;
      return { name: carModel, ...rest };
    });
  }, []);

  const renameCarType = useCallback((data) => {
    return data?.map((item) => {
      const { categoryName, ...rest } = item;
      return { name: categoryName, ...rest };
    });
  }, []);

  const renameCarFeature = useCallback((data) => {
    return data?.map((item) => {
      const { carFeature, ...rest } = item;
      return { name: carFeature, ...rest };
    });
  }, []);

  const availableSeat = useCallback(
    (carType, seatList) => {
      if (carType) {
        let data = carTypeList?.find((item) => item._id === carType);
        return seatList?.filter((item) => +item?._id >= +data?.numberOfSeats);
      } else {
        return [];
      }
    },
    [carTypeList]
  );

  useEffect(() => {
    if (feature.length)
      setErrMsg((prev) => ({
        ...prev,
        carFeature: "",
      }));
    if (location?.length)
      setErrMsg((prev) => ({
        ...prev,
        location: "",
      }));
  }, [feature, location]);
  // console.log("seates", availableSeat(seatList, 5));
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  // const handleInput = (event) => {
  //     const { name, value, type, files } = event.target;
  //     if (type === 'file') {
  //         const file = files[0];
  //         if (file) {
  //             const reader = new FileReader();
  //             reader.onloadend = () => {

  //                 const base64Data = reader.result;
  //                 setCarDetail((prevFormData) => ({ ...prevFormData, [name]: base64Data }));
  //             };
  //             reader.readAsDataURL(file);
  //         }
  //     } else {
  //         setCarDetail((prevFormData) => ({ ...prevFormData, [name]: value }));
  //         if (name === 'carMake') {
  //             dispatch(getCarModal(value))
  //         }
  //     }
  // };
  const carRegExp = /^[A-Za-z0-9\s-]+$/; //  regex for general car registration numbers (letters, numbers, spaces, hyphens)
  const alphanumericRegex = /^[a-zA-Z0-9]*$/; // regex for number and alphabets
  var numberRegex = /^\d+$/;
  const handleInput = async (event) => {
    const { name, value, type, files } = event.target;
    if (name) {
      setErrMsg((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
    if (name === "carType") {
      setCarDetail({ ...CarDetail, seat: "" });
    }
    if (type === "file") {
      const file = files[0];
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          // Store both base64 data and filename in the state
          setCarDetail((prevFormData) => ({
            ...prevFormData,
            [name]: { base64: reader.result, filename: file.name },
          }));
          try {
            let formData = new FormData();
            formData.append("type", name);
            formData.append("image", file);

            dispatch(carUploadImages(formData)).then((res) => {
              dispatch(setCarImagesResponse({ [name]: res?.payload.data }));
            });
          } catch (error) {
            console.log(error);
          }
        };
        reader.readAsDataURL(file);
      }
    } else {
      if (name === "registrationNum") {
        // if (value === "" || carRegExp.test(value)) {
        if (value === "" || alphanumericRegex.test(value)) {
          setCarDetail((prevFormData) => ({
            ...prevFormData,
            [name]: value,
          }));
        }
      } else {
        if (name === "power" || name === "motor" || name === "speed") {
          if (value === "" || numberRegex.test(value)) {
            setCarDetail((prevFormData) => ({
              ...prevFormData,
              [name]: value,
            }));
          }
        } else {
          setCarDetail((prevFormData) => ({
            ...prevFormData,
            [name]: value,
          }));
        }
      }
      if (name === "carMake") {
        dispatch(getCarModal(value));
      }
    }
  };

  const manufactureYears = Array.from(
    { length: 125 },
    (_, index) => 2024 - index
  );
  const yearList = manufactureYears.map((year) => ({ _id: year, name: year }));

  const handleIncrease = () => {
    let newErrMsg = {};
    let errorCheck = 0;
    if (CarDetail.carModel === "" || !CarDetail.carModel) {
      newErrMsg = { ...newErrMsg, carModel: "Please Enter Car Model" };
      errorCheck = 1;
    }
    if (CarDetail.carMake === "" || !CarDetail.carMake) {
      newErrMsg = { ...newErrMsg, carMake: "Please Enter Car Make" };
      errorCheck = 1;
    }
    if (CarDetail.carType === "" || !CarDetail.carType) {
      newErrMsg = { ...newErrMsg, carType: "Please Enter Car Type" };
      errorCheck = 1;
    }
    if (CarDetail.manufactureYr === "" || !CarDetail.manufactureYr) {
      newErrMsg = {
        ...newErrMsg,
        manufactureYr: "Please Enter Manufature year",
      };
      errorCheck = 1;
    }
    if (CarDetail.registrationNum === "" || !CarDetail.registrationNum) {
      newErrMsg = {
        ...newErrMsg,
        registrationNum: "Please Enter Registration Number",
      };
      errorCheck = 1;
    } else if (
      CarDetail.registrationNum?.length < 6 ||
      CarDetail.registrationNum?.length > 12
    ) {
      newErrMsg = {
        ...newErrMsg,
        registrationNum:
          "Registration Number must be between 6 and 12 characters",
      };
      errorCheck = 1;
      // } else if (!carRegExp.test(CarDetail.registrationNum)) {
    } else if (!alphanumericRegex.test(CarDetail.registrationNum)) {
      newErrMsg = {
        ...newErrMsg,
        registrationNum: "Registration Number contain only letters and numbers",
      };
      errorCheck = 1;
    }
    if (CarDetail.seat === "" || !CarDetail.seat) {
      newErrMsg = {
        ...newErrMsg,
        seat: "Please Enter seating Capacity",
      };
      errorCheck = 1;
    }
    if (CarDetail.mileage === "" || !CarDetail.mileage) {
      newErrMsg = { ...newErrMsg, mileage: "Please Enter Mileage" };
      errorCheck = 1;
    } else if (
      CarDetail.mileage?.length < 1 ||
      // CarDetail.mileage?.length > 6 ||
      (CarDetail.mileage?.length > 1 && CarDetail.mileage[0] === "0")
    ) {
      newErrMsg = {
        ...newErrMsg,
        mileage: "Please enter a mileage of 1 or more",
        // "Minimum length is 1 digit, Maximum length is 6 digit, and first digit cannot be 0",
      };
      errorCheck = 1;
    }
    //  else if (CarDetail.mileage <= 1 || CarDetail.mileage > 100000) {
    //   newErrMsg = {
    //     ...newErrMsg,
    //     mileage: "Mileage must be between 1 and 100,000",
    //   };
    //   errorCheck = 1;
    // }
    if (CarDetail.fuelType === "" || !CarDetail.fuelType) {
      newErrMsg = { ...newErrMsg, fuelType: "Please Enter Fuel Type" };
      errorCheck = 1;
    }
    if (CarDetail.motor === "" || !CarDetail.motor) {
      newErrMsg = { ...newErrMsg, motor: "Please enter Motor Capacity" };
      errorCheck = 1;
    } else if (
      CarDetail.motor?.length < 2 ||
      CarDetail.motor?.length > 4 ||
      (CarDetail.motor?.length === 4 && CarDetail.motor[0] === "0")
    ) {
      newErrMsg = {
        ...newErrMsg,
        motor:
          "Minimum length is 2 digit, Maximum length is 4 digit, and first digit cannot be 0",
      };
      errorCheck = 1;
    } else if (CarDetail.motor <= 0) {
      newErrMsg = {
        ...newErrMsg,
        motor: "Invalid Motor Capacity",
      };
      errorCheck = 1;
    }
    // if (CarDetail.speed === "") {
    //   newErrMsg = { ...newErrMsg, speed: "Please Enter max speed" };
    //   errorCheck = 1;
    // } else if (
    //   CarDetail.speed?.length < 2 ||
    //   CarDetail.speed?.length > 3 ||
    //   (CarDetail.speed?.length === 3 && CarDetail.speed[0] === "0")
    // ) {
    //   newErrMsg = {
    //     ...newErrMsg,
    //     speed:
    //       "Minimum length is 2 digit, Maximum length is 3 digit, and first digit cannot be 0",
    //   };
    //   errorCheck = 1;
    // } else if (CarDetail.speed < 0 || CarDetail.speed > 999) {
    //   newErrMsg = {
    //     ...newErrMsg,
    //     motor: "Top speed must be between 100 and 500",
    //   };
    //   errorCheck = 1;
    // }
    if (!CarDetail.speed) {
      newErrMsg = { ...newErrMsg, speed: "Please enter max speed" };
      errorCheck = 1;
    } else if (CarDetail.speed.length !== 3 || CarDetail.speed[0] === "0") {
      newErrMsg = {
        ...newErrMsg,
        speed: "Top speed must be a 3-digit number and cannot start with 0",
      };
      errorCheck = 1;
    } else if (CarDetail.speed < 100 || CarDetail.speed >= 500) {
      newErrMsg = {
        ...newErrMsg,
        speed: "Top speed must be between 100 and 500",
      };
      errorCheck = 1;
    }
    // if (CarDetail.power === "" || !CarDetail.power) {
    //   newErrMsg = { ...newErrMsg, power: "Please Enter power" };
    //   errorCheck = 1;
    // } else if (
    //   CarDetail.power?.length < 2 ||
    //   CarDetail.power?.length > 4 ||
    //   (CarDetail.power?.length === 4 && CarDetail.power[0] === "0")
    // ) {
    //   newErrMsg = {
    //     ...newErrMsg,
    //     power:
    //       "Minimum length is 2 digit, Maximum length is 4 digit, and first digit cannot be 0",
    //   };
    //   errorCheck = 1;
    // } else if (CarDetail.power <= 0) {
    //   newErrMsg = {
    //     ...newErrMsg,
    //     power: "Please Enter valid power",
    //   };
    //   errorCheck = 1;
    // }
    if (feature?.length === 0) {
      newErrMsg = { ...newErrMsg, carFeature: "Please Select Features" };
      errorCheck = 1;
    }
    if (location === "") {
      newErrMsg = {
        ...newErrMsg,
        location: "Please Enter Pickup Location",
      };
      errorCheck = 1;
    }
    if (CarDetail.carFrontImg === "" || !CarDetail.carFrontImg) {
      newErrMsg = { ...newErrMsg, carFrontImg: "Please Upload Image" };
      errorCheck = 1;
    }
    if (CarDetail.carBackImg === "" || !CarDetail.carBackImg) {
      newErrMsg = { ...newErrMsg, carBackImg: "Please Upload Image" };
      errorCheck = 1;
    }
    if (CarDetail.carLeftImg === "" || !CarDetail.carLeftImg) {
      newErrMsg = { ...newErrMsg, carLeftImg: "Please Upload Image" };
      errorCheck = 1;
    }
    if (CarDetail.carRightImg === "" || !CarDetail.carRightImg) {
      newErrMsg = { ...newErrMsg, carRightImg: "Please Upload Image" };
      errorCheck = 1;
    }
    if (CarDetail.carSeatsImg === "" || !CarDetail.carSeatsImg) {
      newErrMsg = { ...newErrMsg, carSeatsImg: "Please Upload Image" };
      errorCheck = 1;
    }
    if (CarDetail.carInteriorImg === "" || !CarDetail.carInteriorImg) {
      newErrMsg = { ...newErrMsg, carInteriorImg: "Please Upload Image" };
      errorCheck = 1;
    }
    if (CarDetail.carDashboardImg === "" || !CarDetail.carDashboardImg) {
      newErrMsg = { ...newErrMsg, carDashboardImg: "Please Upload Image" };
      errorCheck = 1;
    }
    if (CarDetail.carChassisImg === "" || !CarDetail.carChassisImg) {
      newErrMsg = { ...newErrMsg, carChassisImg: "Please Upload Image" };
      errorCheck = 1;
    }
    if (CarDetail.numberPlateImg === "" || !CarDetail.numberPlateImg) {
      newErrMsg = { ...newErrMsg, numberPlateImg: "Please Upload Image" };
      errorCheck = 1;
    }
    if (Object.keys(newErrMsg).length > 0) {
      const firstErrorField = Object.keys(newErrMsg)[0];
      setTimeout(() => {
        scroller.scrollTo(firstErrorField, {
          duration: 300,
          delay: 0,
          smooth: "easeInOutQuart",
          offset: -150, // Adjust offset here
        });
      }, 500);
    }
    setErrMsg(newErrMsg);
    // if (CarDetail.carModel === '' || CarDetail.carType === '' || CarDetail.manufactureYr === '' || CarDetail.registrationNum === '' || CarDetail.registrationNum.length >= 6  || CarDetail.seat === '' || CarDetail.mileage === '' || CarDetail.fuelType === '' || CarDetail.motor === '' || CarDetail.speed === '' || CarDetail.power === '' || feature?.length === 0 || location === '' || CarDetail.carFrontImg === '' || CarDetail.carBackImg === '' || CarDetail.carLeftImg === '' || CarDetail.carRightImg === '') {
    if (errorCheck === 1) {
      return false;
    } else {
      dispatch(increaseStep());
      // Store car details including features
      const carDetailsWithFeatures = {
        ...CarDetail,
        carFeature: feature, // Include features in the CarDetail object
        carLocation: location,
        gpsAvaiblity: gpsAvaiblity,
        driverToggle:driverToggle,
      };
      dispatch(storeCarDetails(carDetailsWithFeatures));
      // dispatch(storeCarDetails(CarDetail))
      scrollToTop();
    }
  };
  useEffect(() => {
    // console.log(CarDetail?.carModel,999)
    // console.log(carModalList,9999)
    // console.log(CarDetail?.carType,6666)
    if (CarDetail?.carModel) {
      const type =
        carModalList?.length &&
        carModalList.find(
          (ele) => ele?._id.trim() === CarDetail?.carModel.trim()
        );
      //  console.log(type?.carCategory,654)
      setCarDetail((prevFormData) => ({
        ...prevFormData,
        carType: type?.carCategory,
      }));
    } else {
      setCarDetail((prevFormData) => ({
        ...prevFormData,
        carType: "",
      }));
    }
  }, [CarDetail?.carModel]);

  return (
    <>
      <div className="car-list-form">
        <h3 className="accentColor mt-5">Please Enter Car Details</h3>
        <div className="row mb-4 g-3 m-0 align-items-md-baseline">
          <div className="col-md-3" name="carMake">
            <SelectInput
              isDisable={editCarID}
              labelName="Car Make:"
              placeholder="Enter Car Make"
              value={CarDetail?.carMake}
              onChange={handleInput}
              options={renameCarMake(carMakeList)}
              name="carMake"
              id="carmake"
              error={!!errmsg?.carMake}
              helperText={errmsg?.carMake}
            />
          </div>

          <div className="col-md-3" name="carModel">
            <SelectInput
              isDisable={editCarID}
              labelName="Car Model:"
              placeholder="Enter Car Model"
              value={CarDetail?.carModel}
              onChange={handleInput}
              options={renameCarModal(carModalList)}
              name="carModel"
              id="carmodel"
              error={!!errmsg?.carModel}
              helperText={errmsg?.carModel}
            />
          </div>
          <div className="col-md-3" name="carType">
            <SelectInput
              disable={true}
              isDisable={editCarID}
              labelName="Car Type:"
              placeholder="Enter Car Type"
              value={CarDetail?.carType}
              onChange={handleInput}
              options={renameCarType(carTypeList)}
              name="carType"
              id="cartype"
              error={!!errmsg?.carType}
              helperText={errmsg?.carType}
            />
          </div>
          <div className="col-md-3" name="manufactureYr">
            <SelectInput
              isDisable={editCarID}
              labelName="Year of Manufacture:"
              placeholder="Enter Year of Manufacture"
              value={CarDetail?.manufactureYr}
              onChange={handleInput}
              options={yearList}
              name="manufactureYr"
              id="calmodelyear"
              error={!!errmsg?.manufactureYr}
              helperText={errmsg?.manufactureYr}
            />
          </div>
          <div className="col-md-3" name="registrationNum">
            <TextInput
              isDisable={editCarID}
              type="text"
              labelName="Registration Number:"
              id="registrationNumber"
              placeholder="Enter Number"
              size="small"
              name="registrationNum"
              value={CarDetail?.registrationNum}
              onChange={handleInput}
              error={!!errmsg?.registrationNum}
              helperText={errmsg?.registrationNum}
            />
          </div>
          <div className="col-md-3" name="seat">
            <SelectInput
              // isDisable={editCarID}
              labelName="Number of Seats:"
              placeholder="Enter Number of Seats"
              value={CarDetail?.seat}
              onChange={handleInput}
              // options={seatList}
              options={availableSeat(CarDetail?.carType, seatList)}
              name="seat"
              id="seatingcapacity"
              error={!!errmsg?.seat}
              helperText={errmsg?.seat}
            />
          </div>
          <div className="col-md-3" name="mileage">
            <TextInput
              // isDisable={editCarID}
              type="number"
              labelName="Mileage:"
              id="mileage"
              placeholder="Enter Mileage"
              size="small"
              name="mileage"
              value={CarDetail?.mileage}
              onChange={handleInput}
              error={!!errmsg?.mileage}
              helperText={errmsg?.mileage}
            />
          </div>
          <div className="col-md-3" name="fuelType">
            <SelectInput
              // isDisable={editCarID}
              labelName="Fuel Type:"
              placeholder="Enter Fuel Type"
              value={CarDetail?.fuelType}
              onChange={handleInput}
              options={FuelType}
              name="fuelType"
              id="fueltype"
              error={!!errmsg?.fuelType}
              helperText={errmsg?.fuelType}
            />
          </div>
          <div className="col-md-3" name="motor">
            <TextInput
              // isDisable={editCarID}
              type="number"
              labelName="Motor:"
              id="motor"
              placeholder="cc"
              size="small"
              name="motor"
              value={CarDetail?.motor}
              onChange={handleInput}
              error={!!errmsg?.motor}
              helperText={errmsg?.motor}
            />
          </div>
          <div className="col-md-3" name="speed">
            <TextInput
              // isDisable={editCarID}
              type="number"
              labelName="Top Speed:"
              id="topspeed"
              placeholder="Enter Top Speed"
              size="small"
              name="speed"
              value={CarDetail?.speed}
              onChange={handleInput}
              error={!!errmsg?.speed}
              helperText={errmsg?.speed}
            />
          </div>
          {/* <div className="col-md-3" name="power">
            <TextInput
              // isDisable={editCarID}
              type="number"
              labelName="Power:"
              id="power"
              placeholder="Enter Power"
              size="small"
              name="power"
              value={CarDetail?.power}
              onChange={handleInput}
              error={!!errmsg?.power}
              helperText={errmsg?.power}
            />
          </div> */}

          <div className="col-md-3" name="carFeature">
            <MultipleSelectChip
              labelName="Features:"
              placeholder="Select Features"
              // value={CarDetail?.carFeature}
              value={carDetails?.carFeature}
              setFeature={setFeature}
              feature={feature}
              options={renameCarFeature(carFeaturesList)}
              // options={carFeaturesList}
              name="carFeature"
              id="carFeature"
              error={!!errmsg?.carFeature}
              helperText={errmsg?.carFeature}
            />
          </div>
        </div>
        <h3 className="accentColor mt-5">
          Please Select Pickup Location
          <span className="text-danger">*</span>
        </h3>

        <div className="row my-3 g-1 m-0" name="location">
          {/* <Location
            placeholder="Enter Pick-up location"
            error={!!errmsg?.location}
            helperText={errmsg?.location}
            setLocation={setLocation}
            location={location}
          /> */}
          <MapWithModal
            placeholder="Enter Pick-up location"
            error={!!errmsg?.location}
            helperText={errmsg?.location}
            setLocation={setLocation}
            location={location}
          />
        </div>
        <div className="d-flex align-items-center pb-3">
          <div className="d-flex align-items-center">
            <h5
              className="secondaryColor pointer"
              onClick={() => (editCarID ? null : setChecked(!gpsAvaiblity))}
            >
              With Gps
            </h5>
            <Switch
              // disabled={editCarID ? true : false}
              checked={gpsAvaiblity}
              onChange={handleChange}
              inputProps={{ "aria-label": "controlled" }}
            />
          </div>
          <div className="d-flex align-items-center justify-content-center ">
            <h5
              className="secondaryColor pointer"
              onClick={() => setDriverChecked(!driverToggle)}
            >
              With Driver
            </h5>
            <Switch
              checked={driverToggle}
              onChange={(e) => setDriverChecked(e.target.checked)}
              inputProps={{ "aria-label": "With Driver" }}
            />
          </div>
        </div>
        <p className="text-center car-list-form-p ">Car Images</p>
        <div className="row my-2 g-3 m-0">
          <div className="col-md-3" name="carFrontImg">
            <p className="input-label my-2">
              Front Image:<span className="text-danger">*</span>
            </p>
            <div className="file-input">
              <label
                className={`file-input__label ${
                  errmsg?.carFrontImg ? "error" : null
                }`}
                htmlFor="carFrontImg"
              >
                <input
                  // disabled={editCarID}
                  type="file"
                  accept="image/*"
                  name="carFrontImg"
                  id="carFrontImg"
                  className="file-input__input"
                  onChange={handleInput}
                />
                {CarDetail?.carFrontImg ? (
                  <img
                    className="upload-doc mx-auto pointor"
                    src={
                      CarDetail?.carFrontImg?.base64
                        ? CarDetail?.carFrontImg.base64
                        : `${baseURL}${CarDetail?.carFrontImg}`
                    }
                  />
                ) : (
                  // src={`${CarDetail?.carFrontImg?.base64}`} />
                  <>
                    <MdOutlineFileUpload className="upload-icon" />
                    <span className="text-truncate">Upload</span>
                  </>
                )}

                {/* {(CarDetail?.carFrontImg) ?
                                    <img className='upload-doc mx-auto pointor' src={`${CarDetail?.carFrontImg}`} />
                                    :
                                    <>
                                        <MdOutlineFileUpload className='upload-icon' />
                                        <span className="text-truncate" >Upload</span>
                                    </>

                                } */}
              </label>
              <p className="location-err">{errmsg.carFrontImg}</p>
            </div>
          </div>
          <div className="col-md-3" name="carBackImg">
            <p className="input-label my-2">
              Back Image:<span className="text-danger">*</span>
            </p>
            <div className="file-input">
              <label
                className={`file-input__label ${
                  errmsg?.carBackImg ? "error" : null
                }`}
                htmlFor="carBackImg"
              >
                <input
                  // disabled={editCarID}
                  type="file"
                  accept="image/*"
                  name="carBackImg"
                  id="carBackImg"
                  className="file-input__input"
                  onChange={handleInput}
                />
                {CarDetail?.carBackImg ? (
                  <img
                    className="upload-doc mx-auto pointor"
                    src={
                      CarDetail?.carBackImg.base64
                        ? CarDetail?.carBackImg.base64
                        : `${baseURL}${CarDetail?.carBackImg}`
                    }

                    // src={`${CarDetail?.carBackImg.base64}`}
                  />
                ) : (
                  <>
                    <MdOutlineFileUpload className="upload-icon" />
                    <span className="text-truncate">Upload</span>
                  </>
                )}
              </label>
              <p className="location-err">{errmsg.carBackImg}</p>
            </div>
          </div>
          <div className="col-md-3" name="carLeftImg">
            <p className="input-label my-2">
              Left Image:<span className="text-danger">*</span>
            </p>
            <div className="file-input">
              <label
                className={`file-input__label ${
                  errmsg?.carLeftImg ? "error" : null
                }`}
                htmlFor="carLeftImg"
              >
                <input
                  // disabled={editCarID}
                  type="file"
                  accept="image/*"
                  name="carLeftImg"
                  id="carLeftImg"
                  className="file-input__input"
                  onChange={handleInput}
                />
                {CarDetail?.carLeftImg ? (
                  <img
                    className="upload-doc mx-auto pointor"
                    // src={`${CarDetail?.carLeftImg?.base64}`}
                    src={
                      CarDetail?.carLeftImg.base64
                        ? CarDetail?.carLeftImg.base64
                        : `${baseURL}${CarDetail?.carLeftImg}`
                    }
                  />
                ) : (
                  <>
                    <MdOutlineFileUpload className="upload-icon" />
                    <span className="text-truncate">Upload</span>
                  </>
                )}
              </label>
              <p className="location-err">{errmsg.carLeftImg}</p>
            </div>
          </div>
          <div className="col-md-3" name="carRightImg">
            <p className="input-label my-2">
              Right Image:<span className="text-danger">*</span>
            </p>
            <div className="file-input">
              <label
                className={`file-input__label ${
                  errmsg?.carRightImg ? "error" : null
                }`}
                htmlFor="carRightImg"
              >
                <input
                  // disabled={editCarID}
                  type="file"
                  accept="image/*"
                  name="carRightImg"
                  id="carRightImg"
                  className="file-input__input"
                  onChange={handleInput}
                />
                {CarDetail?.carRightImg ? (
                  <img
                    className="upload-doc mx-auto pointor"
                    // src={`${CarDetail?.carRightImg.base64}`}
                    src={
                      CarDetail?.carRightImg.base64
                        ? CarDetail?.carRightImg.base64
                        : `${baseURL}${CarDetail?.carRightImg}`
                    }
                  />
                ) : (
                  <>
                    <MdOutlineFileUpload className="upload-icon" />
                    <span className="text-truncate">Upload</span>
                  </>
                )}
              </label>
              <p className="location-err">{errmsg.carRightImg}</p>
            </div>
          </div>
          <div className="col-md-3" name="carRightImg">
            <p className="input-label my-2">
              Interior Image:<span className="text-danger">*</span>
            </p>
            <div className="file-input">
              <label
                className={`file-input__label ${
                  errmsg?.carInteriorImg ? "error" : null
                }`}
                htmlFor="carInteriorImg"
              >
                <input
                  // disabled={editCarID}
                  type="file"
                  accept="image/*"
                  name="carInteriorImg"
                  id="carInteriorImg"
                  className="file-input__input"
                  onChange={handleInput}
                />
                {CarDetail?.carInteriorImg ? (
                  <img
                    className="upload-doc mx-auto pointor"
                    // src={`${CarDetail?.carInteriorImg.base64}`}
                    src={
                      CarDetail?.carInteriorImg.base64
                        ? CarDetail?.carInteriorImg.base64
                        : `${baseURL}${CarDetail?.carInteriorImg}`
                    }
                  />
                ) : (
                  <>
                    <MdOutlineFileUpload className="upload-icon" />
                    <span className="text-truncate">Upload</span>
                  </>
                )}
              </label>
              <p className="location-err">{errmsg.carInteriorImg}</p>
            </div>
          </div>
          <div className="col-md-3" name="carRightImg">
            <p className="input-label my-2">
              Seats Image:<span className="text-danger">*</span>
            </p>
            <div className="file-input">
              <label
                className={`file-input__label ${
                  errmsg?.carSeatsImg ? "error" : null
                }`}
                htmlFor="carSeatsImg"
              >
                <input
                  // disabled={editCarID}
                  type="file"
                  accept="image/*"
                  name="carSeatsImg"
                  id="carSeatsImg"
                  className="file-input__input"
                  onChange={handleInput}
                />
                {CarDetail?.carSeatsImg ? (
                  <img
                    className="upload-doc mx-auto pointor"
                    // src={`${CarDetail?.carSeatsImg.base64}`}
                    src={
                      CarDetail?.carSeatsImg.base64
                        ? CarDetail?.carSeatsImg.base64
                        : `${baseURL}${CarDetail?.carSeatsImg}`
                    }
                  />
                ) : (
                  <>
                    <MdOutlineFileUpload className="upload-icon" />
                    <span className="text-truncate">Upload</span>
                  </>
                )}
              </label>
              <p className="location-err">{errmsg.carSeatsImg}</p>
            </div>
          </div>
          <div className="col-md-3" name="carDashboardImg">
            <p className="input-label my-2">
              Dashboard Image:<span className="text-danger">*</span>
            </p>
            <div className="file-input">
              <label
                className={`file-input__label ${
                  errmsg?.carDashboardImg ? "error" : null
                }`}
                htmlFor="carDashboardImg"
              >
                <input
                  // disabled={editCarID}
                  type="file"
                  accept="image/*"
                  name="carDashboardImg"
                  id="carDashboardImg"
                  className="file-input__input"
                  onChange={handleInput}
                />
                {CarDetail?.carDashboardImg ? (
                  <img
                    className="upload-doc mx-auto pointor"
                    // src={`${CarDetail?.carDashboardImg.base64}`}
                    src={
                      CarDetail?.carDashboardImg.base64
                        ? CarDetail?.carDashboardImg.base64
                        : `${baseURL}${CarDetail?.carDashboardImg}`
                    }
                  />
                ) : (
                  <>
                    <MdOutlineFileUpload className="upload-icon" />
                    <span className="text-truncate">Upload</span>
                  </>
                )}
              </label>
              <p className="location-err">{errmsg.carDashboardImg}</p>
            </div>
          </div>
          <div className="col-md-3" name="carChassisImg">
            <p className="input-label my-2">
              Chassis Image:<span className="text-danger">*</span>
            </p>
            <div className="file-input">
              <label
                className={`file-input__label ${
                  errmsg?.carChassisImg ? "error" : null
                }`}
                htmlFor="carChassisImg"
              >
                <input
                  // disabled={editCarID}
                  type="file"
                  accept="image/*"
                  name="carChassisImg"
                  id="carChassisImg"
                  className="file-input__input"
                  onChange={handleInput}
                />
                {CarDetail?.carChassisImg ? (
                  <img
                    className="upload-doc mx-auto pointor"
                    // src={`${CarDetail?.carChassisImg.base64}`}
                    src={
                      CarDetail?.carChassisImg.base64
                        ? CarDetail?.carChassisImg.base64
                        : `${baseURL}${CarDetail?.carChassisImg}`
                    }
                  />
                ) : (
                  <>
                    <MdOutlineFileUpload className="upload-icon" />
                    <span className="text-truncate">Upload</span>
                  </>
                )}
              </label>
              <p className="location-err">{errmsg.carChassisImg}</p>
            </div>
          </div>
          <div className="col-md-3" name="numberPlateImg">
            <p className="input-label my-2">
              Number Plate Image:<span className="text-danger">*</span>
            </p>
            <div className="file-input">
              <label
                className={`file-input__label ${
                  errmsg?.numberPlateImg ? "error" : null
                }`}
                htmlFor="numberPlateImg"
              >
                <input
                  // disabled={editCarID}
                  type="file"
                  accept="image/*"
                  name="numberPlateImg"
                  id="numberPlateImg"
                  className="file-input__input"
                  onChange={handleInput}
                />
                {CarDetail?.numberPlateImg ? (
                  <img
                    className="upload-doc mx-auto pointor"
                    // src={`${CarDetail?.numberPlateImg.base64}`}
                    src={
                      CarDetail?.numberPlateImg.base64
                        ? CarDetail?.numberPlateImg.base64
                        : `${baseURL}${CarDetail?.numberPlateImg}`
                    }
                  />
                ) : (
                  <>
                    <MdOutlineFileUpload className="upload-icon" />
                    <span className="text-truncate">Upload</span>
                  </>
                )}
              </label>
              <p className="location-err">{errmsg.numberPlateImg}</p>
            </div>
          </div>
        </div>
      </div>
      {step < 4 && (
        <div className="d-flex justify-content-between">
          {step > 0 && (
            <>
              <button
                onClick={() => {
                  dispatch(decreaseStep());
                  scrollToTop();
                }}
                type="button"
                className="btn d-none d-lg-block  px-5 img-btn mt-5 primaryColor"
              >
                {" "}
                Back{" "}
              </button>
              <button
                onClick={() => {
                  dispatch(decreaseStep());
                  scrollToTop();
                }}
                type="button"
                className="btn d-block d-lg-none px-3 img-btn mt-5 primaryColor"
              >
                <HiOutlineArrowLeft />
              </button>
            </>
          )}
          {step < 3 ? (
            <>
              <button
                onClick={() => {
                  handleIncrease();
                }}
                type="button"
                className="btn d-none d-lg-block ms-auto px-5 img-btn mt-5 primaryColor"
              >
                {" "}
                Continue{" "}
              </button>
              <button
                onClick={() => {
                  handleIncrease();
                }}
                type="button"
                className="btn d-block d-lg-none ms-auto px-3 img-btn mt-5 primaryColor"
              >
                {" "}
                <HiOutlineArrowRight />{" "}
              </button>
            </>
          ) : (
            <button
              onClick={(e) => {
                dispatch(increaseStep());
                scrollToTop();
              }}
              type="submit"
              className="btn px-5 img-btn mt-5 primaryColor"
            >
              Submit
            </button>
          )}
        </div>
      )}
    </>
  );
};
export default React.memo(CarDetail);
